// Google Play Store Resource Utilities

/**
 * Get Google Play Store app icon URL
 * @param {string} packageName - The app's package name
 * @param {string} size - Icon size (default: '512x512')
 * @returns {string} - Google Play Store icon URL
 */
export const getAppIconUrl = (packageName, size = '512x512') => {
  return `https://play-lh.googleusercontent.com/${packageName}=w${size}`;
};

/**
 * Get Google Play Store app screenshot URL
 * @param {string} packageName - The app's package name
 * @param {number} index - Screenshot index (0, 1, 2, etc.)
 * @param {string} size - Screenshot size (default: '720x1280')
 * @returns {string} - Google Play Store screenshot URL
 */
export const getAppScreenshotUrl = (packageName, index = 0, size = '720x1280') => {
  return `https://play-lh.googleusercontent.com/${packageName}/screenshot-${index}=w${size}`;
};

/**
 * Get Google Play Store app banner URL
 * @param {string} packageName - The app's package name
 * @param {string} size - Banner size (default: '1024x500')
 * @returns {string} - Google Play Store banner URL
 */
export const getAppBannerUrl = (packageName, size = '1024x500') => {
  return `https://play-lh.googleusercontent.com/${packageName}/banner=w${size}`;
};

/**
 * Get Google Play Store developer page URL
 * @param {string} developerId - The developer ID
 * @returns {string} - Google Play Store developer page URL
 */
export const getDeveloperPageUrl = (developerId) => {
  return `https://play.google.com/store/apps/dev?id=${developerId}`;
};

/**
 * Get Google Play Store app page URL
 * @param {string} packageName - The app's package name
 * @returns {string} - Google Play Store app page URL
 */
export const getAppPageUrl = (packageName) => {
  return `https://play.google.com/store/apps/details?id=${packageName}`;
};

// Nirmal Labs App Package Names (actual package names from Google Play Store)
export const NIRMAL_LABS_APPS = {
  AARTI: 'com.nirmallabs.aarti.hindiaarti',
  NOVEL: 'com.nirmallabs.novelsbooksinenglish',
  MEDIA_PLAYER: 'com.nirmallabs.mediaplayer.musicplayer.videoplayer',
  HINDU_CALENDAR: 'com.nirmallabs.hinducalendar',
  // Add more apps as needed
};

// Developer ID for Nirmal Labs
export const NIRMAL_LABS_DEVELOPER_ID = '5561916917816890433';

// Example usage:
// const aartiIcon = getAppIconUrl(NIRMAL_LABS_APPS.AARTI);
// const aartiScreenshot = getAppScreenshotUrl(NIRMAL_LABS_APPS.AARTI, 0);
// const developerPage = getDeveloperPageUrl(NIRMAL_LABS_DEVELOPER_ID);
